import LocalFiles from "src/modules/local-files";

const commandFiles = new LocalFiles({
  directoryName: "command-audio"
});

export default commandFiles;
